(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kr-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.krTimerStarted) return;
    window.krTimerStarted = true;
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      document.querySelectorAll('[data-kr-timer]').forEach(function (el) {
        var end = Date.parse(el.getAttribute('data-end'));
        var left = Math.floor((end - Date.now()) / 1000);
        if (isNaN(end) || left <= 0) { el.hidden = true; return; }
        var d = Math.floor(left / 86400), h = Math.floor((left % 86400) / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
        el.querySelector('[data-kr-timer-value]').textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
        el.hidden = false;
      });
    }
    tick();
    setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
